module.exports = __webpack_public_path__ + "static/media/check@2xPounds.png?v=241880e6";